<template>
    <div :style="{width, height}">
        <div class="describeClass">{{describeText}}</div>
        <div class="totalClass">{{totalText}} <span class="companyClass">{{companyName}}</span> </div>
        <div class="statisDiv"></div>
    </div>
</template>

<script>
export default {
    props: {
        width: String,
        height: String,
        backImg: String,
        totalText: Number,
        companyName: String,
        describeText: String
    },
    data(){
        return{
        }
    },
}
</script>

<style lang="scss" scoped>
.statisDiv{
    display: flex;
    flex-direction: column;
    margin-top: -20%;
    width: 100%;
    height: 100%;
    background-image: url('../src/assets/imgs/ageBackImg.png');
    background-size: 100% 100%;
    // background-color: #FFFFFF;
}
.genderBackClass{
    display: flex;
    flex-direction: column;
    margin-left: 30%;
    height: 100%;
}
.totalDivClass{
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
}
.totalClass{
    margin-top: -2px;
    font-weight: bold;
    color: white;
    font-size: 22px;
}
.companyClass{
    font-weight: 600;
    font-size: 14px;
    color: white;
    margin-top: 20px;
}
.describeClass{
    // margin-top: -26px;
    color: #adb2d2;
    font-size: 14px;
    font-weight: 500;
    // background-color: #d5ec6e;
    // text-align: left;
}
</style>